import { queryKeys } from "../queryKeys";
import {
  getUserConfigurations,
  type UserConfigurations,
} from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

type UseGetConfigurationsOptions = QueryOptions<UserConfigurations> & {
  accountID: string;
  product?: string;
};

export const useGetUserConfigurations = (
  options: UseGetConfigurationsOptions,
) => {
  const { data, ...rest } = useRequest(
    queryKeys.accounts.configurations(options?.accountID, options?.product),
    () => getUserConfigurations({ ...options }),
    { ...options },
  );

  return { user_configurations: data, ...rest };
};

export default useGetUserConfigurations;
